
















































import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "RecordStoryButton",
  components: { BaseButton },
  props: {
    type: { type: String as () => "photo" | "video", default: "photo" },
    recording: { type: Boolean, default: false },
  },
});
